import styles from "./IntegrationSection.module.css";

const IntegrationSection = () => {
  return (
    <section className={styles.integrationSection}>
      <div className={styles.contentWrapper}>
        <h2 className={styles.heading}>
          Seamless Integration with Your HR Tools
        </h2>
        <p className={styles.description}>
          ToolBox AI works with popular ATS and HR platforms <br />
          <span className={styles.highlight}>
            Workday, BambooHR, Greenhouse, SAP SuccessFactors
          </span>
          , and more. <br />
          Automate every step from parsing to candidate shortlisting, creating a
          frictionless recruitment workflow.
        </p>
        <button className={styles.ctaButton}>
          Integrate with Your HR System
        </button>
      </div>
    </section>
  );
};

export default IntegrationSection;
